module.exports = __webpack_public_path__ + "static/img/MO.11e4716b.png";